// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Kopie aus kraftbogen/frontend/src/lib/auth.ts
import type { AuthModel } from "pocketbase"
import { pb } from "./pb"

/** Kennung = Benutzername oder E-Mail (PocketBase probiert beide Felder). */
export async function login(kennung: string, password: string): Promise<void> {
  await pb.collection("users").authWithPassword(kennung, password)
}

export function logout(): void {
  pb.authStore.clear()
}

export function currentUser(): AuthModel | null {
  return pb.authStore.isValid ? pb.authStore.record : null
}

export function isAuthed(): boolean {
  return pb.authStore.isValid
}
